export const ALLERGEN_CODES = [
  'GLUTEN',
  'CRUSTACEANS',
  'EGGS',
  'FISH',
  'PEANUTS',
  'SOYBEANS',
  'MILK',
  'NUTS',
  'CELERY',
  'MUSTARD',
  'SESAME',
  'SULPHITES',
  'LUPIN',
  'MOLLUSCS',
] as const;

export type TAllergenCode = (typeof ALLERGEN_CODES)[number];

export const ALLERGEN_META: Record<
  TAllergenCode,
  { label: string; hint?: string }
> = {
  GLUTEN: { label: 'Gluten', hint: 'Blé, seigle, orge, avoine' },
  CRUSTACEANS: { label: 'Crustacés', hint: 'Crevettes, crabes, homards' },
  EGGS: { label: 'Œufs' },
  FISH: { label: 'Poissons' },
  PEANUTS: { label: 'Arachides', hint: 'Cacahuètes' },
  SOYBEANS: { label: 'Soja' },
  MILK: { label: 'Lait', hint: 'Y compris lactose' },
  NUTS: { label: 'Fruits à coque', hint: 'Amandes, noisettes, noix...' },
  CELERY: { label: 'Céleri' },
  MUSTARD: { label: 'Moutarde' },
  SESAME: { label: 'Graines de sésame' },
  SULPHITES: {
    label: 'Sulfites',
    hint: 'Anhydride sulfureux / SO2 > 10 mg/kg',
  },
  LUPIN: { label: 'Lupin' },
  MOLLUSCS: { label: 'Mollusques', hint: 'Moules, huîtres, calmars' },
};

export type TAllergenPresence = 'contains' | 'may_contain';

export type TDeclarationStatus = 'declared' | 'declared_none';

export interface IDeclarationLine {
  code: TAllergenCode;
  presence: TAllergenPresence;
}

export interface IVariantDeclarations {
  variantId: string;
  declarations: IDeclarationLine[];
}

export interface IAddonDeclarations {
  addonId: string;
  declarations: IDeclarationLine[];
}

export interface IDeclarationTree {
  status: TDeclarationStatus | 'not_declared';
  declarations: IDeclarationLine[];
  variants: IVariantDeclarations[];
  customAddons: IAddonDeclarations[];
}

export interface IUpdateDeclarationsBody {
  status: TDeclarationStatus;
  declarations: IDeclarationLine[];
  variants: IVariantDeclarations[];
  customAddons: IAddonDeclarations[];
}
